import type Cryptr from "cryptr";
import { GoogleSpreadsheet, GoogleSpreadsheetRow } from "google-spreadsheet";
import * as Ons from "react-onsenui";
import imageCompression from "browser-image-compression";
import { ChangeEvent } from "react";

export const secrets =
  "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";

let DOC: GoogleSpreadsheet | null = null;
let DOCLoader: Promise<GoogleSpreadsheet | null> | null = null;

export const demoSheet = async () => {
  const pass = window.localStorage.getItem("pass");
  if (pass == null) {
    throw new Error("No saved password.");
  }
  const cryptr: Cryptr = new (
    window as unknown as { Cryptr: typeof Cryptr }
  ).Cryptr(pass);
  let details: {
    private_key: string;
    sheet: string;
    client_email: string;
  } | null = null;
  try {
    const stringResult = cryptr.decrypt(secrets);
    details = JSON.parse(stringResult);
  } catch (e) {
    throw new Error("FAILED: to login with password");
  }

  if (details == null) {
    throw new Error("FAILED: issue parsing");
  }
  // Initialize the sheet - doc ID is the long id in the sheets URL
  const doc: GoogleSpreadsheet = new (window as any).gsheet.GoogleSpreadsheet(
    details.sheet
  );

  // Initialize Auth - see https://theoephraim.github.io/node-google-spreadsheet/#/getting-started/authentication
  await doc.useServiceAccountAuth({
    // env var values are copied from service account credentials generated by google
    // see "Authentication" section in docs for more info
    client_email: details.client_email,
    private_key: details.private_key,
  });

  await doc.loadInfo(); // loads document properties and worksheets
  DOC = doc;
  return doc;
};

export const loadOrGet = async () => {
  if (DOC != null) {
    console.log(">> DOC ALREADY EXIST");
    return DOC;
  }

  if (DOCLoader == null) {
    console.log(">> CREATING DOC LOADER PROMISE");
    DOCLoader = demoSheet();
  }
  console.log(">> WAITING FOR DOC LOADER");
  const d = await DOCLoader;
  console.log(">> REC DOC LOADER");
  return d;
};

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as unknown as string);
    reader.readAsDataURL(blob);
  });
}

export const compressImage = async (
  event: ChangeEvent<HTMLInputElement>,
  team: string,
  step_index: number,
  cb: (imageData: string) => unknown
) => {
  if (event.target == null) {
    return;
  }
  const imageFile = (event.target as HTMLInputElement).files?.[0];
  if (!imageFile) {
    return;
  }

  console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
  console.log(`originalFile size ${(imageFile?.size ?? 0) / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 1.8,
    maxWidthOrHeight: 480,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(
      "compressedFile instanceof Blob",
      compressedFile instanceof Blob
    ); // true
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    const imageBase64 = await blobToBase64(compressedFile);
    await writeImage(imageBase64, team, step_index);
    cb(imageBase64.split(",", 2)[1]);
    // await uploadToServer(compressedFile); // write your own logic
  } catch (error) {
    console.log(error);
  }
};

export const writeImage = async (
  imageData: string,
  team: string,
  step_index: number
) => {
  const doc = await loadOrGet();
  const imageSections = imageData.split(",", 2)[1].match(/.{1,30000}/g) || [];
  const sheet = doc!.sheetsByTitle["Images"]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  const lastRow = await sheet.addRow({
    image_status: "UPLOADING",
    image_team: team,
    image_step_index: step_index + 1,
  }); // can pass in { limit, offset }

  await sheet.loadCells({
    startRowIndex: lastRow.rowIndex - 1,
    endRowIndex: lastRow.rowIndex,
    startColumnIndex: 4,
    endColumnIndex: 128,
  });
  for (let i = 0; i < imageSections.length; ++i) {
    const dataCell = sheet.getCell(lastRow.rowIndex - 1, i + 4);
    dataCell.value = imageSections[i];
  }
  await sheet.saveUpdatedCells();
  lastRow.image_status = "HEY";
  await lastRow.save();
};

export const getSteps = async () => {
  const doc = await loadOrGet();
  const team = window.localStorage.getItem("team");
  if (team === null) {
    return [] as GoogleSpreadsheetRow[];
  }

  const sheet = doc!.sheetsByTitle[team]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  const rows = await sheet.getRows(); // can pass in { limit, offset }
  return rows;
  // console.log("LOL", rows[0].HEY);
  // rows[1].HEY = "pizza";
  // await rows[1].save();

  // adding / removing sheets
  // const newSheet = await doc.addSheet({ title: "Sheet1" });
  // await newSheet.delete();
};

export const getStep = async (
  stepKey: string
): Promise<GoogleSpreadsheetRow | null> => {
  const doc = await loadOrGet();
  const team = window.localStorage.getItem("team");
  if (team === null) {
    return null;
  }

  const sheet = doc!.sheetsByTitle[team]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  const rows = await sheet.getRows(); // can pass in { limit, offset }
  let findRow: GoogleSpreadsheetRow | null = null;
  for (const row of rows) {
    if (row.step_id === stepKey) {
      findRow = row;
      break;
    }
  }
  if (findRow == null) {
    throw new Error(`Row not found for key: ${stepKey}`);
  }

  return findRow!;
};

export const loadTeams = async (): Promise<string[]> => {
  const doc = await loadOrGet();
  const sheets = doc!.sheetsByTitle;
  const teams = Object.keys(sheets).filter((title) => title.startsWith("Team"));
  return teams.sort();
};

export const loadRules = async (): Promise<string[]> => {
  const doc = await loadOrGet();
  const rules = doc!.sheetsByTitle["Rules"];
  const rows = await rules.getRows();
  return rows.map((r) => r.rules as string);
};

export const getImage = async (imageIndex: number): Promise<string | null> => {
  const doc = await loadOrGet();
  const sheet = doc!.sheetsByTitle["Images"]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]

  await sheet.loadCells({
    startRowIndex: imageIndex - 1,
    endRowIndex: imageIndex,
    startColumnIndex: 4,
    endColumnIndex: 128,
  });

  let dataString = "";
  for (let i = 0; i < 128; ++i) {
    const dataCell = sheet.getCell(imageIndex - 1, i + 4);
    if (!dataCell || dataCell.value === "" || dataCell.value == null) {
      break;
    }
    dataString += dataCell.value;
  }

  return dataString;
};

export const fullyWriteStepComplete = async (
  stepIndex: number,
  navigator: Ons.Navigator,
  setLoading: (status: boolean) => unknown
) => {
  const doc = await loadOrGet();
  const team = window.localStorage.getItem("team");
  if (team === null) {
    setLoading(false);

    return null;
  }

  const sheet = doc!.sheetsByTitle[team]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  const rows = await sheet.getRows({ limit: 1, offset: stepIndex - 2 });
  if (!rows) {
    setLoading(false);
    return;
  }
  console.log("ROW I HAVE IS", rows[0]!.step_id);
  rows[0].step_status = "DONE";
  await rows[0].save();
  navigator.popPage({ data: { refresh: true, navigator } });
};
